// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7243) return "static/chunks/7243-9b7c796d80340915.js";
	if (chunkId === 5399) return "static/chunks/5399-b37fe5691208abd4.js";
	if (chunkId === 6755) return "static/chunks/6755-e33d9cc5b0074421.js";
	if (chunkId === 528) return "static/chunks/528-97d2c752d4004df3.js";
	if (chunkId === 9633) return "static/chunks/9633-2db0dac84bf14c6e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1863":"527cca711c9ab022","1890":"1f2f9942c081ee45","1929":"b207dbfa53a0d05b","3470":"cb50e06a9abe03a1","5649":"9928bdcdfd62610b","9657":"fd5c1171a55805ab"}[chunkId] + ".js";
};